import React from 'react';
import { ImageProps } from '.';

const SvgFastshipEmblemBadge = ({ size = 67, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 3.0454545454545454)) || 22}
      fill='none'
      viewBox='0 0 67 22'
      {...props}
    >
      <path
        fill='#fff'
        d='M0 4c0-2.21 1.905-4 4.254-4h58.492C65.096 0 67 1.79 67 4v14c0 2.21-1.905 4-4.254 4H4.254C1.904 22 0 20.21 0 18V4Z'
      />
      <path
        fill='#E2E5E6'
        d='M62.746 21v1H4.254v-1h58.492Zm3.19-3V4c0-1.605-1.34-2.916-3.026-2.996L62.746 1H4.254c-1.762 0-3.19 1.343-3.19 3v14c0 1.657 1.428 3 3.19 3v1l-.22-.005C1.86 21.891.117 20.251.006 18.206L0 18V4c0-2.21 1.905-4 4.254-4h58.492C65.096 0 67 1.79 67 4v14l-.005.206c-.11 2.045-1.855 3.685-4.03 3.79l-.219.004v-1c1.762 0 3.19-1.343 3.19-3Z'
      />
      <g fill='#3D4F6F' clipPath='url(#FastshipEmblemBadge_svg__a)'>
        <path d='M30.72 9.67h1.028v1.177H30.72v5.199h-1.407V5.937h1.407v3.732ZM51.298 11.28H47.39v.634h2.803v2.465h-5.661v.556h5.929v1.044h-7.325v-2.555h5.65v-.5h-5.661v-1.01h2.847v-.634h-3.897v-1.033h9.223v1.033ZM59.996 14.202H54.67v.655h5.616v1.122h-7.012v-2.788h5.304v-.634h-5.326v-1.1h6.744v2.745ZM34.762 14.735h5.795v1.133h-7.224v-2.777h1.43v1.644ZM17.23 7.71c.265 0 .49.132.606.353l1.602 3.066c.067.133.082.291.034.43l-.634 1.858a.427.427 0 0 1-.422.291H17.34c-.055 0-.103.032-.116.083-.41 1.087-1.431 1.852-2.317 1.852-.886 0-1.37-.715-1.097-1.751.028-.101-.041-.184-.15-.184h-2.794c-.054 0-.102.033-.115.083-.41 1.087-1.432 1.852-2.318 1.852-.885 0-1.369-.715-1.096-1.751.027-.101-.04-.184-.15-.184h-.722c-.225 0-.361-.17-.293-.372l.456-1.36a.427.427 0 0 1 .422-.29h5.907c.314 0 .573-.17.669-.456L14.723 8a.427.427 0 0 1 .422-.29h2.085Z' />
        <path
          fillRule='evenodd'
          d='M23.54 9.192h.649V6.848h1.161v6.865H22.37V6.848h1.172v2.344Zm0 3.355h.649v-2.233h-.648v2.233ZM26.913 9.192h.659V6.848h1.161v6.865h-2.97V6.848h1.15v2.344Zm0 3.355h.659v-2.233h-.659v2.233Z'
          clipRule='evenodd'
        />
        <path d='M41.462 12.536H32.16v-1.133h9.3v1.133ZM59.996 7.903h1.373v1.144h-1.373v2.033h-1.43V5.937h1.43v1.966Z' />
        <path
          fillRule='evenodd'
          d='M53.654 7.593h2.076v-1.2h1.43v4.41h-4.924v-4.41h1.418v1.2Zm0 2.099h2.076V8.659h-2.076v1.033Z'
          clipRule='evenodd'
        />
        <path d='M40.334 8.959H34.74v.722h5.783v1.066h-7.202v-2.8h5.583V7.26H33.3V6.17h7.035V8.96ZM12.897 9.012c.225 0 .362.17.293.373l-.347 1.024a.426.426 0 0 1-.423.29H5.81c-.224 0-.36-.17-.292-.372l.347-1.024a.427.427 0 0 1 .423-.291h6.61ZM47.38 6.726h3.047V7.77h-2.87c.28.589 1.318 1.072 3.372 1.156l-.413 1.043c-1.887-.089-3.193-.566-3.84-1.333-.642.767-1.955 1.244-3.853 1.333l-.39-1.043c2.037-.084 3.07-.567 3.36-1.156h-2.846V6.726h3.025v-.8h1.407v.8ZM13.797 6.357c.224 0 .36.17.292.373l-.347 1.024a.426.426 0 0 1-.422.29H9.23c-.224 0-.36-.17-.292-.372l.347-1.024a.426.426 0 0 1 .423-.29h4.088Z' />
      </g>
      <defs>
        <clipPath id='FastshipEmblemBadge_svg__a'>
          <path fill='#fff' d='M0 0h56v13H0z' transform='translate(5.5 4.5)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgFastshipEmblemBadge;
